import { component } from 'picoapp';

export default component(async (node) => {
  const dataSource = node.dataset.source;
  const { breakpoint } = node.dataset;

  const getExtension = (url) => url.split(/[#?]/)[0].split('.').pop().trim();

  const insertSource = (source) => {
    const type = `video/${getExtension(source)}`;

    node.insertAdjacentHTML(
      'beforeend',
      `<source src="${source}" type="${type}">`,
    );
  };

  const checkViewPort = () => {
    window.addEventListener('resize', checkViewPort);

    if (breakpoint === 'desktop') {
      if (window.innerWidth > 768) {
        insertSource(dataSource);
        window.removeEventListener('resize', checkViewPort);
      }
    }

    if (breakpoint === 'mobile') {
      if (window.innerWidth > 0 && window.innerWidth < 768) {
        insertSource(dataSource);
        window.removeEventListener('resize', checkViewPort);
      }
    }
  };

  checkViewPort();
});
